import { FunctionComponent } from 'react';
import { useLocation } from 'react-router';
import PropertyAssociationAreaItem from './components/PropertyAssociationAreaItem';
import { GetPropertyAssociationConfigResponse } from './models/GetPropertyAssociationConfigResponse';

type Props = {
    propertyAssociation: GetPropertyAssociationConfigResponse;
};

const SelectPropertyAssociationArea: FunctionComponent<Props> = ({ propertyAssociation }) => {
    const location = useLocation();
    const returnPath = (location.state as { returnPath?: string } | null)?.returnPath;

    return (
        <div className="app__inner mt-4">
            <div className="text-center">
                <h1 className="large-heading">{propertyAssociation.name}</h1>
                <h2>Välj ett område</h2>
                <p className="preamble">Det här är alternativen du kan välja mellan.</p>
            </div>
            <div className="boxlist">
                {propertyAssociation.areas?.map((x) => (
                    <PropertyAssociationAreaItem key={x.propertyAssociationAreaId} propertyAssociationId={propertyAssociation.propertyAssociationId} value={x} returnPath={returnPath} />
                ))}
            </div>
        </div>
    );
};

export default SelectPropertyAssociationArea;
